module.exports = __webpack_public_path__ + "officialStatic/img/pkb.db228a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/pkb.png
// module id = IVjO
// module chunks = 0